"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gas = void 0;
const Units_1 = require("./Units");
class Gas {
    static DEFAULT = '30000000000000';
    constructor() { }
    static unitsToDecimals(units) {
        if (units === 'T') {
            return 12;
        }
        if (units === 'G') {
            return 9;
        }
        if (units === 'M') {
            return 6;
        }
        if (units === 'K') {
            return 3;
        }
        return units;
    }
    /**
     * Parse from specific units and return a fixed string
     * @example
     * const rawGas = Gas.parse('5', 'T'); // '5000000000000'
     * @param gas human readable gas
     * @param units units
     */
    static parse(gas, units) {
        return Units_1.Units.parse(gas, Gas.unitsToDecimals(units)).toFixed(0);
    }
    /**
     * Format in specific units and return a fixed string
     * @example
     * const humanReadableGas = Gas.format('5000000000000', 'T'); // '5'
     * @param gas raw gas
     * @param units units
     * @param decimalPlaces decimal places
     */
    static format(gas, units, decimalPlaces) {
        gas = Units_1.Units.format(gas, Gas.unitsToDecimals(units));
        if (decimalPlaces) {
            return gas.toFixed(decimalPlaces);
        }
        else {
            return gas.toFixed();
        }
    }
}
exports.Gas = Gas;
//# sourceMappingURL=Gas.js.map